import React from "react";
import { useSelector } from "react-redux";

import MobileDialog from "./MobileDialog";
import useWindowDimensions from "../hooks/useWinDims";

import { Card, makeStyles, CardContent, Typography, Link, Fab } from "@material-ui/core";
import { Add, Check } from "@material-ui/icons";

const useStyles = makeStyles(
  () => ({
    card: {
      borderRadius: "12px",
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      height: "100%"
    },
    cardFooter: {
      width: "100%",
      display: "inline-flex",
      justifyContent: "space-between",
      alignItems: "baseline"
    },
    cardText: {
      height: "calc(100% - 40px)",
      paddingBottom: "16px !important"
    },
    carouselItemWrapper: {
      height: "100%"
    },
    heading: {
      fontWeight: "bold",
      width: "100%",
      display: "inline-flex",
      justifyContent: "space-between",
      marginBottom: "10px"
    },
    textOverflow: {
      display: "flex",
      maskImage: "linear-gradient(to bottom, black 65%, transparent 100%)",
      overflow: "hidden"
    },
    text: {
      display: "flex",
      userSelect: "none",
      width: "100%"
    }
  }),
  { name: "MobileStepOne" }
);

export default function CarouselItem(props) {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const { width, height } = useWindowDimensions();

  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardStepTwo = useSelector((state) => state.checkedCardStepTwo);

  const toggleDialog = React.useCallback(() => {
    setDialogOpen(!dialogOpen);
  }, [dialogOpen]);

  const isSelected = React.useMemo(
    () => checkedCardStepOne === props.item.text || checkedCardStepTwo === props.item.text,
    [checkedCardStepOne, checkedCardStepTwo, props.item.text]
  );

  const updateSelected = React.useCallback(() => {
    props.onClick(props.item.text);
  }, [props]);

  return (
    <div className={classes.carouselItemWrapper}>
      <MobileDialog heading={props.item.heading} onClose={toggleDialog} open={dialogOpen} text={props.item.text} />
      <Card className={classes.card}>
        <CardContent className={classes.cardText}>
          <Typography className={classes.heading} onClick={updateSelected}>
            {props.item.heading}
          </Typography>
          <div className={classes.textOverflow} style={{ height: height - 288.5 }}>
            <Typography className={classes.text} color={"textSecondary"} variant={"body2"}>
              {props.item.text}
            </Typography>
          </div>
          <div className={classes.cardFooter}>
            <Link onClick={toggleDialog} variant={"body2"}>
              Mehr Lesen
            </Link>
            <Fab size="small" color="primary" aria-label="add" className={classes.margin} onClick={updateSelected}>
              {isSelected ? <Check /> : <Add />}
            </Fab>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
